import { IAdvisor } from "./Advisor";
import { IProject } from "./Project";

export interface IAdvisorActivity {
    id: number;
    uuid: string;
    key: string;
    name: string;
    description?: string;
    default_share_value: number;
    is_system_wide: boolean;
    is_active: boolean;
    project?: IProject | null;
    system_activity?: IAdvisorActivity | null;
    project_overrides?: IAdvisorActivity[];
    project_share_value?: number | null;
    created_at: string;
    updated_at: string;
}

// Helper type for creating/updating activities
export type AdvisorActivityInput = Omit<IAdvisorActivity, 'id' | 'uuid' | 'created_at' | 'updated_at' | 'project_overrides'>;

export enum AdvisorActivityLedgerEntryStatus {
    PENDING = "pending",
    APPROVED = "approved",
    ACQUIRED = "acquired",
    REJECTED = "rejected"
}

export enum AdvisorActivityLedgerEntrySharesType {
    DEFAULT = "default",
    COMPANY = "company"
}

export interface IAdvisorActivityLedgerEntry {
    id: number;
    uuid: string;
    advisor: IAdvisor;
    activity: IAdvisorActivity;
    project: IProject;
    shares_earned: number;
    notes: string | null;
    metadata?: any;
    created_at: string;
    updated_at: string;
    status: AdvisorActivityLedgerEntryStatus;
    approved_at: string | null;
    acquired_at: string | null;
    rejected_at: string | null;
    shares_type?: AdvisorActivityLedgerEntrySharesType | null;
    is_deleted?: boolean;
}

// Response types for API calls
export interface IActivityResponse {
    activities: IAdvisorActivity[];
    total: number;
}

export interface IActivityRecordResponse {
    data: IAdvisorActivityLedgerEntry[];
    total: number;
}

export interface IAdvisorShareLedgerResponse {
    data: IAdvisorActivityLedgerEntry;
    total_shares: number;
    recent_activities: IAdvisorActivityLedgerEntry[];
}

export interface IAdvisorLedgerResponse {
    ledger: IAdvisorActivityLedgerEntry[];
    message?: string;
}

export interface IRecordActivityResponse {
    ledgerEntry: IAdvisorActivityLedgerEntry;
} 